import * as React from "react";
import "../staff/NewStaff.scss";
import "./NewEmergency.scss";
import HandleUIError from "../../utils/HandleUIError";
import toast from "react-hot-toast";

//components
import { Modal, Input, Button, Spinner, IconButton } from "../Atomics";
import { cilX } from "@coreui/icons";
import { saveEmergency } from "../../services/emergencyService";
import { createActivityReq } from "../../services/activityLogService";
import PhoneInput from 'react-phone-number-input'

interface Props {
  visible: boolean;
  closeModal: () => void;
  refreshParents: () => void;
}

const NewEmergency: React.FC<Props> = ({
  visible,
  closeModal,
  refreshParents,
}) => {
  const [name, setName] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [phone, setPhone] = React.useState<string>("");
  const [addParentLoading, setAddParentLoading] =
    React.useState<boolean>(false);

  const handleInputName = (e: any) => {
    setName(e.target.value);
  };

  const handleInputMail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleInputPhone = (e: any) => {
    setPhone(e.target.value);
  };

  async function addParent(
    name: string,
    email: string,
    phone: string
  ): Promise<void> {

    if (phone?.length > 10) {
      toast.error("Invalid phone number");
      return;
    }
    setAddParentLoading(true);
    try {
      if (name === "" || name === null) {
        toast.error("Name cannot be empty");
        setAddParentLoading(false);
      } else {
        await saveEmergency(name, phone);
        await refreshParents();
        toast.success("Emergency Contact added");
        setAddParentLoading(false);
        onCloseModal();
        await createActivityReq('Emergency Contact Added Successfully')
      }
    } catch (e) {
      setAddParentLoading(false);
      HandleUIError(e);
    }
  }

  function onCloseModal() {
    setName("");
    setEmail("");
    setPhone("");
    closeModal();
  }

  return (
    <Modal visible={visible} >
      <div className="new-staff-container h-auto">
        <div className="new-staff-header">
          <p className="text-light py-2 ps-4 fs-5">Add Emergency Contact</p>
          <IconButton icon={cilX} className="me-3" onClick={closeModal} />
        </div>

        <div className="mt-5">
          <p className="text-light fs-5 ms-3 pt-3">Name</p>
          <Input
            maxLength={60}
            className="mt-2 mb-3 ms-3 search-phone-input"
            onChange={handleInputName}
            autoFocus
          />
          <p className="text-light fs-5 ms-3 pt-3">Phone</p>
          <PhoneInput
            value={phone}
            onChange={(e: any) => setPhone(e)}
            defaultCountry="US"
            autoFocus
            className="mt-2 mb-3 ms-3 search-phone-input bg-transparent"
          />
          <Button
            disabled={addParentLoading}
            className="mt-7 button-add px-4 mb-3"
            onClick={() => addParent(name, email, phone)}
          >
            {!addParentLoading ? "Add" : <Spinner />}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NewEmergency;
